import { render, staticRenderFns } from "./LandingForm.vue?vue&type=template&id=2ceadbc6&scoped=true&"
import script from "./LandingForm.vue?vue&type=script&lang=js&"
export * from "./LandingForm.vue?vue&type=script&lang=js&"
import style0 from "./LandingForm.vue?vue&type=style&index=0&id=2ceadbc6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ceadbc6",
  null
  
)

export default component.exports